import { render } from "./ModalInformativoProdutos.vue?vue&type=template&id=6c943376&scoped=true"
import script from "./ModalInformativoProdutos.vue?vue&type=script&lang=js"
export * from "./ModalInformativoProdutos.vue?vue&type=script&lang=js"

import "./ModalInformativoProdutos.vue?vue&type=style&index=0&id=6c943376&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c943376"]])

export default __exports__